export const GATHERING_TERM = 'outing';
export const GATHERING_TERM_PLURAL = 'outings';
